/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, 'blob_create/', Blob_Create_Data.frames);
  fixPivot(mainTex, 'blob_push/', Blob_Push_Data.frames);
  fixPivot(mainTex, 'blob_rotate/', Blob_Rotate_Data.frames);

  for (const key in Blob_Create_Data.animations) {
    addAnimation(scene.anims, key, Blob_Create_Data, 'blob_create');
  }
  for (const key in Blob_Push_Data.animations) {
    addAnimation(scene.anims, key, Blob_Push_Data, 'blob_push');
  }
  for (const key in Blob_Rotate_Data.animations) {
    addAnimation(scene.anims, key, Blob_Rotate_Data, 'blob_rotate');
  }

  const blobFillPause = new Phaser.Animations.Animation(scene.anims,'fill_pause', {
    frames: scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'purpleSheet/purpleSheet2-',
      frames: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1, 1, 1, 1, 1, 1]
    }),
    repeat: -1
  });
  scene.anims.add('fill_pause', blobFillPause);

  const blobRotatePause = new Phaser.Animations.Animation(scene.anims,'fill_pause', {
    frames: scene.anims.generateFrameNames(ABCyaPhaser.Images.DEFAULT_ATLAS, {
      prefix: 'greenSheet/greenSheet-',
      frames: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1, 1, 1, 1, 1, 1]
    }),
    repeat: -1
  });
  scene.anims.add('rotate_pause', blobFillPause);
}

/**
 * 
 * @param {Phaser.Animations.AnimationManager} animationManager 
 * @param {string} key 
 * @returns 
 */
function addAnimation(animationManager, key, data, prefix) {
  if (animationManager.exists(key)) return;

  const frames = [];
  const animationData = data.animations[key];
  animationData.frames.forEach(frameNum => frames.push({ frame: `${prefix}/${frameNum.toString()}` }));
  animationManager.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: (animationData.framerate ?? 24) * (animationData.speed ?? 1),
      key,
      frames,
    }
  );
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

// this data comes from the original game; this is the CreateJs sprite sheet animation export

const Blob_Create_Data = {
  framerate: 24,
  frames: [
    [0, 0, 128, 256, 0, -238, -126],
    [128, 0, 128, 256, 0, -238, -126],
    [256, 0, 128, 256, 0, -238, -126],
    [384, 0, 128, 256, 0, -238, -126],
    [512, 0, 128, 256, 0, -238, -126],
    [640, 0, 128, 256, 0, -238, -126],
    [768, 0, 128, 256, 0, -238, -126],
    [896, 0, 128, 256, 0, -238, -126],
    [1024, 0, 128, 256, 0, -238, -126],
    [1152, 0, 128, 256, 0, -238, -126],
    [1280, 0, 128, 256, 0, -238, -126],
    [1408, 0, 128, 256, 0, -238, -126],
    [1536, 0, 128, 256, 0, -238, -126],
    [1664, 0, 128, 256, 0, -238, -126],
    [1792, 0, 128, 256, 0, -238, -126],
    [0, 256, 128, 256, 0, -238, -126],
    [128, 256, 128, 256, 0, -238, -126],
    [256, 256, 128, 256, 0, -238, -126],
    [384, 256, 128, 256, 0, -238, -126],
    [512, 256, 128, 256, 0, -238, -126],
    [640, 256, 128, 256, 0, -238, -126],
    [768, 256, 128, 256, 0, -238, -126],
    [896, 256, 128, 256, 0, -238, -126],
    [1024, 256, 128, 256, 0, -238, -126],
    [1152, 256, 128, 256, 0, -238, -126]
  ],

  animations: {

    create: {
      speed: 1,
      frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      next: 'pause',
      frequency: 1
    },
    create_pause: { speed: 1, frames: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,24,24,24,24,24] }
  }
};

const Blob_Push_Data = {

  framerate: 24,
  images: ['./assets/images/blob_push_animation.png'],
  frames: [
    [0, 0, 128, 128, 0, -188, -72],
    [128, 0, 128, 128, 0, -188, -72],
    [256, 0, 128, 128, 0, -188, -72],
    [384, 0, 128, 128, 0, -188, -72],
    [512, 0, 128, 128, 0, -188, -72],
    [640, 0, 128, 128, 0, -188, -72],
    [768, 0, 128, 128, 0, -188, -72],
    [896, 0, 128, 128, 0, -188, -72],
    [1024, 0, 128, 128, 0, -188, -72],
    [1152, 0, 128, 128, 0, -188, -72],
    [1280, 0, 128, 128, 0, -188, -72],
    [1408, 0, 128, 128, 0, -188, -72],
    [1536, 0, 128, 128, 0, -188, -72],
    [1664, 0, 128, 128, 0, -188, -72],
    [1792, 0, 128, 128, 0, -188, -72],
    [0, 128, 128, 128, 0, -188, -72],
    [128, 128, 128, 128, 0, -188, -72],
    [256, 128, 128, 128, 0, -188, -72]
  ],
  animations: {

    push: {
      speed: 1,
      frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
      next: 'pause',
      frequency: 1
    },
    push_pause: { speed: 1, frames: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17, 17, 17, 17, 17, 17] }
  }
};

const Blob_Rotate_Data = {
  framerate: 24,
  images: ['./assets/images/blob_rotate_animation.png'],
  frames: [
    [0, 0, 128, 128, 0, -237, -163],
    [128, 0, 128, 128, 0, -237, -163],
    [256, 0, 128, 128, 0, -237, -163],
    [384, 0, 128, 128, 0, -237, -163],
    [512, 0, 128, 128, 0, -237, -163],
    [640, 0, 128, 128, 0, -237, -163],
    [768, 0, 128, 128, 0, -237, -163],
    [896, 0, 128, 128, 0, -237, -163],
    [1024, 0, 128, 128, 0, -237, -163],
    [1152, 0, 128, 128, 0, -237, -163],
    [1280, 0, 128, 128, 0, -237, -163],
    [1408, 0, 128, 128, 0, -237, -163],
    [1536, 0, 128, 128, 0, -237, -163],
    [1664, 0, 128, 128, 0, -237, -163],
    [1792, 0, 128, 128, 0, -237, -163],
    [0, 128, 128, 128, 0, -237, -163],
    [128, 128, 128, 128, 0, -237, -163],
    [256, 128, 128, 128, 0, -237, -163],
    [384, 128, 128, 128, 0, -237, -163],
    [512, 128, 128, 128, 0, -237, -163],
    [640, 128, 128, 128, 0, -237, -163],
    [768, 128, 128, 128, 0, -237, -163],
    [896, 128, 128, 128, 0, -237, -163],
    [1024, 128, 128, 128, 0, -237, -163],
    [1152, 128, 128, 128, 0, -237, -163],
    [1280, 128, 128, 128, 0, -237, -163],
    [1408, 128, 128, 128, 0, -237, -163],
    [1536, 128, 128, 128, 0, -237, -163],
    [1664, 128, 128, 128, 0, -237, -163],
    [1792, 128, 128, 128, 0, -237, -163],
    [0, 256, 128, 128, 0, -237, -163]
  ],
  animations: {

    rotate: {
      speed: 1,
      frames: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23, 24,25,26,27,28,29,30],
      next: 'pause',
      frequency: 1
    },
    rotate_pause_1: { speed: 1, frames: [0] }

  }
};